import QuoteRequestForm from '../components/QuoteRequestForm'
import Wrapper from '../components/Wrapper'

function QuotePage(){
    return (
        <div>
            <Wrapper title={ "Request a Quote" }>
            <div>
                <p>Request your free upholstery quote</p>
                <QuoteRequestForm />
            </div>
            </Wrapper>
        </div>
    )
}

export default QuotePage